import React, { FC } from 'react';
import { Loader } from '~/components';
import { useGetTransaction } from '~/hooks/headTransactions';

interface Props {
  objectId: string;
  TabContent: FC<any>;
  [key: string]: any;
}

const TransactionTabWrapper: FC<Props> = ({ objectId, TabContent, ...rest }) => {
  const { data: transaction, isLoading } = useGetTransaction(objectId, { staleTime: Infinity });

  if (isLoading) return <Loader />;

  return <TabContent {...rest} record={transaction} />;
};

export default TransactionTabWrapper;
